import './PureCloudLogin.css'
import React, { useEffect, Fragment } from 'react'
import { initiatePkceFlow } from '../../../services/utils'

const PureCloudLogin = () => {
    useEffect(() => {
        void initiatePkceFlow(sessionStorage.getItem('purecloud-csp-env'))
    }, [])

    return (<Fragment></Fragment>)
}

export default PureCloudLogin
